import ServiceCard from "./ServiceCard";

const ServiceListDisplay = ({
  services,
  activeTab,
  setActiveTab,
  isServiceSelected,
  onServiceSelect,
  currencyCode,
  selectDisabled,
  t,
}) => {
  const tabs = [
    { key: "oem", tooltip: "Motor.com Services" },
    { key: "recommended", tooltip: "Motor.com and the shop Services" },
    { key: "optional", tooltip: "Optional Services" },
  ];

  return (
    <>
      {/* Tabs */}
      <ul className="nav nav-tabs d-none d-lg-flex" id="myTab" role="tablist">
        {tabs.map((tab) => (
          <li className="nav-item" key={tab.key} role="presentation">
            <button
              className={`nav-link${activeTab === tab.key ? " active" : ""}`}
              id={`${tab.key}-tab`}
              type="button"
              role="tab"
              aria-controls={`${tab.key}-tab-pane`}
              aria-selected={activeTab === tab.key}
              onClick={() => setActiveTab(tab.key)}
              title={tab.tooltip}
            >
              {t(tab.key)}
            </button>
          </li>
        ))}
      </ul>

      {/* Content */}
      <div className="tab-content accordion" id="myTabContent">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`tab-pane fade accordion-item${
              activeTab === tab.key ? " show active" : ""
            }`}
            id={`${tab.key}-tab-pane`}
            role="tabpanel"
            aria-labelledby={`${tab.key}-tab`}
            tabIndex="0"
          >
            {/* Accordion Header (Mobile) */}
            <h2 className="accordion-header d-lg-none" id={`heading-${tab.key}`}>
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse-${tab.key}`}
                aria-expanded={activeTab === tab.key}
                aria-controls={`collapse-${tab.key}`}
              >
                {t(tab.key)} {t("services")}
              </button>
            </h2>

            {/* Accordion Body */}
            <div
              id={`collapse-${tab.key}`}
              className={`accordion-collapse collapse ${
                activeTab === tab.key ? "show" : ""
              } d-lg-block`}
              aria-labelledby={`heading-${tab.key}`}
              data-bs-parent="#myTabContent"
            >
              <div className="accordion-body px-0">
                {services[tab.key]?.services.length > 0 ? (
                  <div className="services-list-scroll">
                    {services[tab.key]?.services.map((service, idx) => (
                      <ServiceCard
                        key={`${tab.key}-service-${idx}`}
                        service={service}
                        type={tab.key}
                        isSelected={isServiceSelected(service)}
                        currencyCode={currencyCode}
                        onSelect={onServiceSelect}
                        selectDisabled={selectDisabled}
                        t={t}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="alert alert-info">
                    {t("no_record_found")}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ServiceListDisplay;